import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import "./index.scss";
import FeedbackDialog from "./dialog";
import axios from "axios";

import peopleSad from "../../images/peoplesad.svg";
import peopleHappy from "../../images/people.svg";
import likeWhite from "../../images/likewhite.svg";
import likeBrown from "../../images/like.svg";
import dislikeWhite from "../../images/dislikewhite.svg";
import dislikeBrown from "../../images/dislike.svg";
import bookingcom from "../../images/bookingcom.svg";
import google from "../../images/google.svg";
import expedia from "../../images/expedia.svg";
import tripadvisor from "../../images/tripadvisor.svg";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";

import { useFormik } from "formik";
import * as Yup from "yup";

const backendBaseUrl = process.env.REACT_APP_CART_API_BASE_URL;

const FEEDBACK_TYPES = {
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE",
  NONE: "NONE",
};

export const CustomerFeedback = () => {
  const [feedback, setFeedback] = useState(FEEDBACK_TYPES.NONE);
  const [open, setOpen] = useState(false);
  const [hotelDetails, setHotelDetails] = useState({});

  const { hotelId } = useParams();

  useEffect(() => {
    if (hotelId) {
      axios.get(`${backendBaseUrl}/hotel/review/${hotelId}`).then((res) => {
        setHotelDetails(res.data);
      });
    }
  }, [hotelId]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setFeedback(FEEDBACK_TYPES.NONE);
    window.close();
    setOpen(false);
  };

  const handleCustomerFeedbackType = (feedbackType) => {
    if (feedback === feedbackType) {
      setFeedback(FEEDBACK_TYPES.NONE);
    } else {
      setFeedback(feedbackType);
    }
  };

  const validateSchema = Yup.object().shape({
    name: Yup.string().required("Your name is required!"),
    roomNo: Yup.string().required("Room no is required!"),
    feedback: Yup.string().notRequired(),
    location: Yup.boolean().notRequired(),
    staff: Yup.boolean().notRequired(),
    comfort: Yup.boolean().notRequired(),
    propertyAmenities: Yup.boolean().notRequired(),
    cleanliness: Yup.boolean().notRequired(),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      roomNo: "",
      feedback: "",
      location: false,
      staff: false,
      comfort: false,
      propertyAmenities: false,
      cleanliness: false,
    },
    enableReinitialize: true,
    validationSchema: validateSchema,
    onSubmit: async (values, { resetForm }) => {
      const {
        name,
        roomNo,
        propertyAmenities,
        cleanliness,
        location,
        staff,
        comfort,
        feedback,
      } = values;

      const payload = {
        HotelId: hotelId,
        Name: name,
        RoomNumber: roomNo,
        PropertyAmenities: propertyAmenities ? "Bad" : "",
        Cleanliness: cleanliness ? "Bad" : "",
        Location: location ? "Bad" : "",
        Staff: staff ? "Bad" : "",
        Comfort: comfort ? "Bad" : "",
        Other: feedback,
      };

      axios.post(`${backendBaseUrl}/hotel/review`, payload);
      resetForm();

      setOpen(true);
    },
  });

  return (
    <div className="customer-feedback-container">
      <Header hotelDetails={hotelDetails} />
      {open && <FeedbackDialog onClose={handleClose} />}

      <div className="inner-container">
        <h1 className="title">How was your stay with us?</h1>

        <div className="main-image-container">
          <img
            src={feedback === FEEDBACK_TYPES.NEGATIVE ? peopleSad : peopleHappy}
            alt="people"
            className="people-img"
            loading="lazy"
          />
          <div className="secondary-container">
            <div className="feedback-response-container">
              <FeedbackImage
                onClick={() =>
                  handleCustomerFeedbackType(FEEDBACK_TYPES.POSITIVE)
                }
                imageName={
                  Boolean(feedback === FEEDBACK_TYPES.POSITIVE)
                    ? likeWhite
                    : likeBrown
                }
                isPositive={Boolean(feedback === FEEDBACK_TYPES.POSITIVE)}
              />
              <FeedbackImage
                onClick={() =>
                  handleCustomerFeedbackType(FEEDBACK_TYPES.NEGATIVE)
                }
                imageName={
                  Boolean(feedback === FEEDBACK_TYPES.NEGATIVE)
                    ? dislikeWhite
                    : dislikeBrown
                }
                isNegative={Boolean(feedback === FEEDBACK_TYPES.NEGATIVE)}
              />
            </div>

            <div className="feedback-web">
              <FeedbackForm
                hotelDetails={hotelDetails}
                feedback={feedback}
                onSubmit={handleOpen}
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className="feedback-mobile">
          <FeedbackForm
            hotelDetails={hotelDetails}
            feedback={feedback}
            onSubmit={handleOpen}
            formik={formik}
          />
        </div>
      </div>
    </div>
  );
};

const FeedbackForm = ({ feedback, onSubmit, hotelDetails, formik }) => {
  const redirect = (url) => {
    window.location.replace(url);
  };

  return (
    <>
      {feedback === FEEDBACK_TYPES.POSITIVE && (
        <div className="positive-feedback-container">
          {hotelDetails.bookingUrl && (
            <CompanyPositiveTile
              image={bookingcom}
              onClick={() => redirect(hotelDetails.bookingUrl)}
            />
          )}
          {hotelDetails.tripadvisorUrl && (
            <CompanyPositiveTile
              image={tripadvisor}
              onClick={() => redirect(hotelDetails.tripadvisorUrl)}
            />
          )}
          {hotelDetails.googleUrl && (
            <CompanyPositiveTile
              image={google}
              onClick={() => redirect(hotelDetails.googleUrl)}
            />
          )}
          {hotelDetails.googleUrl && (
            <CompanyPositiveTile
              image={expedia}
              onClick={() => redirect(hotelDetails.expediaUrl)}
            />
          )}
        </div>
      )}

      {feedback === FEEDBACK_TYPES.NEGATIVE && (
        <div>
          <CompnayNegativeFeedbackForm onSubmit={onSubmit} formik={formik} />
        </div>
      )}
    </>
  );
};

export const Header = ({ hotelDetails }) => {
  return (
    <div className="address-header">
      <p>{hotelDetails.name}</p>
      {(hotelDetails.phoneNumber || hotelDetails.website) && (
        <p>
          {hotelDetails.phoneNumber}
          &nbsp;&nbsp;{hotelDetails.phoneNumber && hotelDetails.website && "|"}
          &nbsp;&nbsp;
          {hotelDetails.website}
        </p>
      )}
    </div>
  );
};

export const FeedbackImage = ({
  imageName,
  isPositive,
  isNegative,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="feedback-image-container"
      style={feedbackImageBackgroundColor({ isPositive, isNegative })}
    >
      <img src={imageName} alt={"thumb"} loading="lazy" />
    </div>
  );
};

const CompanyPositiveTile = ({ image, onClick }) => {
  return (
    <div className="company-tile-container" onClick={onClick}>
      <p>Complete Review with</p>
      <img src={`${image}`} alt={image} loading="lazy" />
    </div>
  );
};

const CompnayNegativeFeedbackForm = ({ onSubmit, formik }) => {
  const { errors, touched, values, handleChange, handleSubmit } = formik;
  return (
    <div className="company-negative-form">
      <p>Your feedback means a lot to us, please tell us what went wrong.</p>

      <input
        type="text"
        className={`form-input-text ${
          touched.name && errors.name ? "error-form-input" : ""
        }`}
        placeholder="Your Name"
        onChange={handleChange}
        name="name"
        value={values.name}
      />
      {touched.name && errors.name && (
        <p className="errorMessage">{errors.name}</p>
      )}

      <input
        type="text"
        className={`form-input-text ${
          touched.roomNo && errors.roomNo ? "error-form-input" : ""
        }`}
        placeholder="Room No."
        onChange={handleChange}
        name="roomNo"
        value={values.roomNo}
      />
      {touched.roomNo && errors.roomNo && (
        <p className="errorMessage">{errors.roomNo}</p>
      )}

      <div>
        <div className="checkboxes-container">
          <Chip
            icon={<ThumbDownAltIcon />}
            label="Location"
            variant="outlined"
            onClick={() => {
              handleChange({
                target: { value: !values.location, name: "location" },
              });
            }}
            {...(values.location
              ? {
                  color: "secondary",
                  className: "negative-feedback-selected",
                  style: { backgroundColor: "#ffdbdb" },
                }
              : {})}
          />

          <Chip
            icon={<ThumbDownAltIcon />}
            label="Staff"
            variant="outlined"
            onClick={() => {
              handleChange({
                target: { value: !values.staff, name: "staff" },
              });
            }}
            {...(values.staff
              ? {
                  color: "secondary",
                  className: "negative-feedback-selected",
                  style: { backgroundColor: "#ffdbdb" },
                }
              : {})}
          />

          <Chip
            icon={<ThumbDownAltIcon />}
            label="Comfort"
            variant="outlined"
            onClick={() => {
              handleChange({
                target: { value: !values.comfort, name: "comfort" },
              });
            }}
            {...(values.comfort
              ? {
                  color: "secondary",
                  className: "negative-feedback-selected",
                  style: { backgroundColor: "#ffdbdb" },
                }
              : {})}
          />
        </div>
        <div className="checkboxes-container">
          <Chip
            icon={<ThumbDownAltIcon />}
            label="Property Amenities"
            variant="outlined"
            onClick={() => {
              handleChange({
                target: {
                  value: !values.propertyAmenities,
                  name: "propertyAmenities",
                },
              });
            }}
            {...(values.propertyAmenities
              ? {
                  color: "secondary",
                  className: "negative-feedback-selected",
                  style: { backgroundColor: "#ffdbdb" },
                }
              : {})}
          />

          <Chip
            icon={<ThumbDownAltIcon />}
            label="Cleanliness"
            variant="outlined"
            onClick={() => {
              handleChange({
                target: { value: !values.cleanliness, name: "cleanliness" },
              });
            }}
            {...(values.cleanliness
              ? {
                  color: "secondary",
                  className: "negative-feedback-selected",
                  style: { backgroundColor: "#ffdbdb" },
                }
              : {})}
          />
        </div>
      </div>

      <textarea
        type="text"
        className="form-input-textarea"
        placeholder="Any other feedback"
        onChange={handleChange}
        name="feedback"
        value={values.feedback}
        rows={3}
      />

      <button className="submit-btn" onClick={handleSubmit}>
        Submit
      </button>
    </div>
  );
};

const feedbackImageBackgroundColor = ({ isPositive, isNegative }) => {
  if (isPositive) {
    return { backgroundColor: "#39CC6F" };
  } else if (isNegative) {
    return { backgroundColor: "#E32C2C" };
  } else {
    return {};
  }
};
